/* The Aesthetic Cove — sleeps to Christmas.
   Fills every [data-sleeps] element with the number of sleeps left until
   25 December, counted on Sydney's calendar ("1 sleep to Christmas" on the
   24th, "Merry Christmas" on the day). After Christmas the line stays hidden.
   The server already printed today's count (snippets/sleeps-text.liquid), so
   this only corrects it when the cached page is a day behind.

   Sydney's date is worked out by hand rather than with Intl.DateTimeFormat,
   which costs a slow phone a fifth of a second to set up. New South Wales
   keeps daylight saving (UTC+11) from 2am on the first Sunday of October to
   3am on the first Sunday of April; the rest of the year is UTC+10. */
(() => {
  const spots = document.querySelectorAll('[data-sleeps]');
  if (!spots.length) return;

  const DAY = 86400000;
  // The first Sunday of a month, as a UTC day number.
  const firstSunday = (year, month) => {
    const first = Date.UTC(year, month, 1);
    return first + ((7 - new Date(first).getUTCDay()) % 7) * DAY;
  };
  const sydneyDate = (now) => {
    const ms = now.getTime();
    const y = new Date(ms + 10 * 3600000).getUTCFullYear();
    // 2am AEST on the October Sunday is 16:00 UTC the Saturday before;
    // 3am AEDT on the April Sunday is 16:00 UTC the Saturday before.
    const dstStart = firstSunday(y, 9) - 8 * 3600000;
    const dstEnd = firstSunday(y, 3) - 8 * 3600000;
    const summer = ms >= dstStart || ms < dstEnd;
    return new Date(ms + (summer ? 11 : 10) * 3600000);
  };

  const local = sydneyDate(new Date());
  const y = local.getUTCFullYear();
  const today = Date.UTC(y, local.getUTCMonth(), local.getUTCDate());
  const sleeps = Math.round((Date.UTC(y, 11, 25) - today) / DAY);
  if (sleeps < 0) return;
  const text = sleeps === 0 ? 'Merry Christmas' : sleeps === 1 ? '1 sleep to Christmas' : `${sleeps} sleeps to Christmas`;

  spots.forEach((spot) => {
    const target = spot.querySelector('[data-sleeps-text]') || spot;
    if (target.textContent !== text) target.textContent = text;
    if (spot.hidden) spot.hidden = false;
  });
})();
